module.exports = "/_next/static/images/c74df9461c9bf78c62e31fb66f29a434-hands-holding-cards-xs@2x.jpg";